const r = ["arbitrage-model-rule"], s = {
  all: r,
  list: (e) => [...r, "list", e]
}, i = ({
  queryClient: e,
  client: t,
  input: l
}) => e.fetchQuery({
  queryKey: s.list(l),
  queryFn: ({ signal: a }) => t.arbitrageModelRule.findAll(l, { signal: a }),
  staleTime: 0,
  // A retry keeps the legacy table in its loading state, where it ignores filter changes.
  retry: !1
});
export {
  s as arbitrageModelRuleKeys,
  i as fetchArbitrageModelRules
};
//# sourceMappingURL=queries.js.map
